import { FunctionField } from 'shared/react-admin/Fields';

import { MerchantsShowNotificationsDeliveryChannelActivityFieldSwitch } from './MerchantsShowNotificationsDeliveryChannelActivityFieldSwitch/MerchantsShowNotificationsDeliveryChannelActivityFieldSwitch';

type MerchantsShowNotificationsDeliveryChannelFieldProps = { label: string; source?: string };

export const MerchantsShowNotificationsDeliveryChannelActivityField: React.FC<
  MerchantsShowNotificationsDeliveryChannelFieldProps
> = ({ label }) => {
  return (
    <FunctionField
      label={label}
      render={() => {
        return <MerchantsShowNotificationsDeliveryChannelActivityFieldSwitch />;
      }}
      sortable={false}
    />
  );
};
